import React, { FC } from "react";
import styles from "./SectionContainer.module.scss";
import clsx from "clsx";
import { BackgroundColor, classForBackground } from "../Backgrounds/background";

interface SectionContainerProps {
  className?: string;
  wrapperClassName?: string;
  backgroundColor?: BackgroundColor;
  spacingTop?: null | "regular" | "compact" | "condensed";
  spacingBottom?: null | "regular" | "compact" | "condensed";
  dataContentName?: null | string;
  id?: string;
}

export const SectionContainer: FC<
  React.PropsWithChildren<SectionContainerProps>
> = ({
  className,
  wrapperClassName,
  backgroundColor = "white",
  children,
  spacingTop = null,
  spacingBottom = null,
  dataContentName = null,
  id
}) => {
  const fixedBackgroundColor =
    backgroundColor == "neutral05" ? "neutral01" : backgroundColor;
  const bgClass = classForBackground(fixedBackgroundColor);
  return (
    <div
      id={id}
      className={clsx(wrapperClassName, styles.background, bgClass)}
      data-content-name={dataContentName}
    >
      <div
        className={clsx(className, styles.sectionContainer, {
          [styles.spacingTopRegular]: spacingTop == "regular",
          [styles.spacingBottomRegular]: spacingBottom == "regular",
          [styles.spacingTopCompact]: spacingTop == "compact",
          [styles.spacingBottomCompact]: spacingBottom == "compact",
          [styles.spacingTopCondensed]: spacingTop == "condensed",
          [styles.spacingBottomCondensed]: spacingBottom == "condensed"
        })}
      >
        {children}
      </div>
    </div>
  );
};
